<template>
    <div @click="moveEmarticonGuide">
<!--        <img :src="require(`/src/assets/images/${data}.png`)" alt="이마트 충전형 온라인 지갑 e마티콘 이용방법 안내 e마티콘" />-->
      <img v-if="data == 'banner_emart_2408'" :src="require(`/src/assets/images/${data}.png`)" alt="이마트 충전형 모바일 지갑 이마티콘 자동 충전 5%추가 혜택 안내 e마티콘" />
      <img v-else :src="require(`/src/assets/images/${data}.png`)" alt="이마트 충전형 모바일 지갑 이마티콘 자동 충전 3%추가 혜택 안내 e마티콘" />
<!--      <img :src="require(`/src/assets/images/${data}.png`)" alt="신한 슈퍼 SOL 신규 가입하고 이마티콘 5천원 받으세요!" />-->
<!--      <img :src="require(`/src/assets/images/${data}.png`)" alt="SC제일은행 신규계좌 개설 후 이마티콘 구매하면 이마티콘 15,000원 추가 증정" />-->
    </div>
</template>

<script>
export default {
    name: 'Banner',
    props: {data : String}
  ,
  methods:{
    moveEmarticonGuide(){

      //가이드 파일명 세팅
      const guideData = this.data.substring(0, 13) + 'guide' + this.data.substring(12);

      this.$router.push({name: "emarticonGuide", query: {data: guideData}})
      // window.location.href = "http://emart.kr/Dzxv";
      // window.location.href = "http://emart.kr/Jqgf";
    },
  }
};
</script>

<style lang="scss" scoped>
    @import "@/assets/styles/common/banner.scss";
</style>